import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AdminSidebar from './adminSidebar';
import '../styles/GlobalStyles.css';

const AdminLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [loggingOut, setLoggingOut] = useState(false);
    const navigate = useNavigate();

    const handleLogout = async () => {
        setLoggingOut(true);
        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/api/auth/logoutUser`,
                {},
                { withCredentials: true }
            );
            localStorage.removeItem('token');
            // alert('Logged out successfully!'); // Optional: keep or remove based on preference
            navigate('/adminlogin');
        } catch (error) {
            console.error('Logout failed:', error);
            alert('Failed to logout. Please try again.');
        }
        setLoggingOut(false);
    };

    return (
        <div className="global-font min-h-screen bg-gray-100">
            {/* Header */}
            <header className="fixed top-0 left-0 right-0 z-50 flex items-center justify-end px-6 bg-white shadow-md h-14">
                <div className="hidden mr-4 text-gray-700 md:block">Welcome, Admin</div>
                <button
                    onClick={handleLogout}
                    disabled={loggingOut}
                    className={`px-4 py-2 text-sm text-white rounded ${loggingOut ? 'bg-red-300 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600'
                        }`}
                >
                    {loggingOut ? 'Logging out...' : 'Logout'}
                </button>
            </header>

            {/* Persistent Sidebar */}
            <AdminSidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                onLogout={handleLogout}
                loggingOut={loggingOut}
            />

            {/* Main Content Area */}
            {/* 
         The padding logic mimics the original dashboard:
         pt-14 (header height)
         md:pl-64 (desktop sidebar width) 
      */}
            <main className="w-full mt-5 pt-14 md:pl-64">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
